/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../../../components/Pagination';
import 'tw-elements';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import { dataService } from '../../../../../services/data.services';
import GlobalContext from '../../../../../components/Context/GloablContext';
// import EmptyScreenBranch from '../components/EmptyScreen';
import CardHeader from '../../../../../components/CardHeader';
import { removeAssociationSelection } from '../../../../ManageAssociation/AssociationSlice';
import EmptyAddScreen from '../../../../../components/EmptyAddScreen'
import { purchaseOrderList , DateFilter} from '../../PurchaseOrderListSlice';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
// import Table from './Components/Table';
import TopBarWithShadow from '../../../../../components/TopBar/TopBarWithShadow';
import Table from './Table';

const PurchaseOrder = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const { setToastErrorMessage, setToastmessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const PurchaseOrderList = useSelector(state => state.purchaseOrderListSlice);
    const { List} = PurchaseOrderList
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({ page_number:  1 })
    }

    /* The above code is a JavaScript React component that defines a function called `getBranch`. This
    function is defined using the `useCallback` hook, which memoizes the function so that it is only
    recreated if any of its dependencies change. */
    const getBranch = useCallback(async () => {
        try {
            const branch_id = await GetBranchId()
            const inventoryId = searchParams.get('inventory_id');
            dispatch(purchaseOrderList(`grn-entry?role=inventory&branch_id=${branch_id}&inventory_id=${inventoryId}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0 && searchParams.get('filter')===null ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found.")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            handleLoadData()
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        // setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        getBranch();
        // getFilterData();
        return(()=>{
            dispatch(removeAssociationSelection())
        })
    }, [searchParams]);

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`branch/${confirmationState.item._id}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Branch ${state} successfully`);
            }
            handleConformationClick();
            setLoading(true)
            getBranch();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }
    urlParams.delete('inventory_id');
    urlParams.delete('inventory_name');
    urlParams.delete('inventory_code');
    return (
        <>
            <CardHeader noPadding>          
                <TopBarWithShadow
                    Tittle={'GRN Entries: ' + searchParams.get('inventory_name')+" [" + searchParams.get('inventory_code')+"]"} isback={true} backLocation={`/inventory-master/inventory-list?${urlParams.toString()}`}
                />
                <div className='mainDataCntnrPageDiv scrollBlue_thick' style={{'padding':'16px 1rem 0px 1rem'}}>

                    {loading ? <ItemShimmer />
                        :<>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                searchParams={searchParams}
                                setLoading={setLoading}
                            />
                            {(List.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </>
                    }
                </div>
            </CardHeader>            
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Branch`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} this Branch ?`}
                        buttonName = {confirmationState.status === 'Reset Password' ? "Reset" : confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default PurchaseOrder;
